import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardApproverService } from '../service/card-approver.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalApproveAcceptComponent } from './modal-approve-accept/modal-approve-accept.component';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ModalsConfirmCardComponent } from '../new-access-card/modals-confirm-card/modals-confirm-card.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-card-approver-result',
  templateUrl: './card-approver-result.component.html'
})
export class CardApproverResultComponent implements OnInit {
  @Input()requestNumber: string;
  formNewcard: UntypedFormGroup;
  submited: boolean;
  card: any;
  alldownloadEnabled = false;
  isReposition = false;
  constructor(private formBuilder: UntypedFormBuilder, private route: ActivatedRoute,
              private dataApi: CardApproverService, public dialog: MatDialog,
              private spinner: NgxSpinnerService, private _snackBar: MatSnackBar,
              private router: Router) {
    this.route.snapshot.paramMap.get('id');
    this.requestNumber = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.formNewcard = this.formBuilder.group({
      // Confirm:[true, Validators.required]
    });
    this.spinner.show('loading');
    this.dataApi.getCard(this.requestNumber)
      .subscribe((data: any) => {
        this.card = data;
        if (this.card.peoples.length > 0) {
          for (const people of this.card.peoples) {
            if (people.imageUpload) { this.alldownloadEnabled = true; }
            if (data.peoples[0].reposition && data.peoples[0].reposition != null) { this.isReposition = true; }
          }
        }

        this.spinner.hide('loading');
      }, (err) => {
        this.spinner.hide('loading');
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });

  }

  getlang() {
    return sessionStorage.getItem('lang');
  }


  downloadOneImage(cardRequest, mdmid, person) {
    this.spinner.show('loading');

    let nameFile = '';
    if (person.passportNumber == null && person.nationalId == null ) {
      nameFile = 'unknown';
    }
    // tslint:disable-next-line:triple-equals
    if (person.passportNumber == null || person.passportNumber == '') {
      nameFile = person.nationalId;
    } else {
      nameFile = person.passportNumber;
    }
    this.dataApi.getImage(cardRequest, mdmid).subscribe(
      (response: any) => {
        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        this.spinner.hide('loading');
        /*downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', 'card-request-images.jpg');
        document.body.appendChild(downloadLink);
        downloadLink.click();*/

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          if (navigator.msSaveBlob) {
            window.navigator.msSaveBlob(new Blob(binaryData), nameFile + '.jpg');
          }
          } else {
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
          downloadLink.setAttribute('download', nameFile + '.jpg');
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }



      }, (err) => {
        this.spinner.hide('loading');
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    );
  }

  downloadAllimages(cardd) {
    this.spinner.show('loading');
    this.dataApi.getAllImage(cardd.requestNumber).subscribe(
      (response: any) => {

        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        this.spinner.hide('loading');


        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          if (navigator.msSaveBlob) {
            window.navigator.msSaveBlob(new Blob(binaryData), 'card-request-images.zip');
          }
        } else {
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
          downloadLink.setAttribute('download', 'card-request-images.zip');
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }

        /*
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', 'card-request-images.zip');
        document.body.appendChild(downloadLink);
        downloadLink.click();*/
      }, (err) => {
        this.spinner.hide('loading');
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    );
  }


  openDialogAccept() {
    this.dialog.open(ModalApproveAcceptComponent,
                     {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.spinner.show('closeOrder');
        this.dataApi.AproveRequestCard(this.requestNumber).subscribe(() => {
          this.spinner.hide('closeOrder');
          this.router.navigate(['/card-approver/list', ]);
        }, (err) => {
          this.spinner.hide('closeOrder');
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        });
      } else {

      }
    });

  }
  openDialogTerm() {
    this.dialog.open(ModalsConfirmCardComponent,
                     {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
      if (accept) {

      } else {

      }
    });

  }

  onSubmit() {
    this.submited = true;
    this.openDialogAccept();
  }


}
